module.exports = __webpack_public_path__ + "static/honest-mobile-logo-bb991d65ef0eecc896f90478555d740a.png";